const footerStyle = {
  foooterContainer: {
    backgroundColor: "white",
    padding: 9,
  },
  copyright: {
    fontSize: 12,
    color: "#cccccc",
    textAlign: "center",
  },
};
export default footerStyle;
